import { SanityProductFilterKey } from '@gelato-api-ui/core/sanity/sanity-product-filter';

export const sanityProductFilterKeysForColorSelection = [
  SanityProductFilterKey.garmentColor,
  SanityProductFilterKey.bagColor,
  SanityProductFilterKey.mugmaterial,
];
